<template>
    <div>
        <Form :data="data" />
        <List :data="data" />
    </div>
</template>

<script>
import Form from './Form'
import List from './List'

export default {
    components: { Form, List },
    methods: {
        async validate() {

            return true
        },
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>